var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.905,
    height: 32.721,
    viewBox: "0 0 22.905 32.721",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-location-on",
    "data-name": "Icon material-location-on",
    d: "M18.952,3A11.444,11.444,0,0,0,7.5,14.452c0,8.589,11.452,21.269,11.452,21.269S30.4,23.042,30.4,14.452A11.444,11.444,0,0,0,18.952,3Zm0,15.543a4.09,4.09,0,1,1,4.09-4.09A4.092,4.092,0,0,1,18.952,18.543Z",
    transform: "translate(-7.5 -3)",
    fill: "#a1a3ef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.529f171ba8f7badc5fb96d816d822f08.svg";
export { ForwardRef as ReactComponent };